import { ApplicationOfferBundleData } from "../../application/application.model";
import { ProductCode } from "../../product/product.model";

// Line of Credit offers at or above this amount belong to the large loan program.
export const LargeLoanProgramThreshold = 400000;

// Interim: Idea Signature offer pages show this Initial Draw Commission instead of the partner's
// own rate until the backend carries a rate per program. The booked commission still uses the
// partner's rate.
export const LargeLoanProgramCommissionRate = 0.06;

// The program's public name. The code calls it the large loan program.
export const LargeLoanProgramName = "Idea Signature";

// Shown on the regular Line of Credit card when a large loan offer sits next to it.
export const StandardLineOfCreditName = "Standard";

export const LargeLoanProgramBankIntegrationNotice =
  `${LargeLoanProgramName} Lines require linking via bank integration`;

export function isLargeLoanProgramOffer(offerBundle: ApplicationOfferBundleData): boolean {
  const offer = offerBundle?.offers?.[0];
  return isLargeLoanProgramAmount(offer?.productCode, offer?.amount);
}

export function isLargeLoanProgramAmount(productCode: ProductCode, amount: number): boolean {
  return productCode === ProductCode.LOC && amount >= LargeLoanProgramThreshold;
}

export interface ProductHeading {
  isLargeLoanProgram: boolean;
  // Small label above the title; null when the title alone names the product.
  label: string;
  title: string;
}

// Card and calculator-box heading: when the application also has large loan program offers, a
// Line of Credit reads "Line of Credit" over "Standard" or over the program name.
export function getProductHeading(
  offerBundle: ApplicationOfferBundleData,
  productName: string,
  largeLoanProgramOffered: boolean
): ProductHeading {
  const isLargeLoanProgram = isLargeLoanProgramOffer(offerBundle);
  const isStandardLineOfCredit =
    largeLoanProgramOffered && !isLargeLoanProgram && offerBundle?.offers?.[0]?.productCode === ProductCode.LOC;

  return {
    isLargeLoanProgram,
    label: isLargeLoanProgram || isStandardLineOfCredit ? productName : null,
    title: isLargeLoanProgram
      ? LargeLoanProgramName
      : isStandardLineOfCredit
        ? StandardLineOfCreditName
        : productName,
  };
}
